export class InventoryTypeFieldOption {
  id: number
  active: boolean
  displayOrder: number
  value: string

  constructor(id: number, active: boolean, displayOrder: number, value: string) {
    this.id = id
    this.active = active
    this.displayOrder = displayOrder
    this.value = value
  }
}
